import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { SubscriptionsRemovingComponent } from '../../shared/components/subscription-removing/subscription-removing.component';

@Component({
    selector: 'sdp-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    standalone: true
})
export class AuthCallbackComponent extends SubscriptionsRemovingComponent implements OnInit, OnDestroy {

  constructor(
    private _authService: AuthService,
    _router: Router) {
    super();
  }

  ngOnInit() {
    super.addSubscription(this._authService.completeAuthentication()
      .pipe(
        switchMap(() => {
          return this._authService.authenticateWithCMS();
        })).subscribe());
  }

  ngOnDestroy() {
    super.clearSubscriptions();
  }
}
